export const MIN_SEARCH_LENGTH = 3;
export const BASE_CLASS_NAME = "eb-search-autocomplete";
export const UNIQUE_ID = "search-autocomplete";
